export const GET_APPEALS_LOAD = 'GET_APPEALS_LOAD';
export const GET_APPEALS_SUCCESS = 'GET_APPEALS_SUCCESS';
export const GET_APPEALS_ERROR = 'GET_APPEALS_ERROR';
export const REDIRECT_TO_CARD = 'REDIRECT_TO_CARD';